export default "__VITE_PUBLIC_ASSET__25528207__"